import { getComponent } from '../utils'
import { h } from 'vue'
import { prefix } from '../prefix'
import Layout from '@/layouts/main-layout.vue'
import { BankOutlined, UsergroupAddOutlined } from '@ant-design/icons-vue'
import { useIdentityStore } from '@/stores/identity/auth'
import type { RouteRecordRaw } from 'vue-router'

export const team_routes: RouteRecordRaw[] = [
  {
    path: '/team/list',
    name: 'team-list',
    component: () => getComponent(`pages/team/team-list.vue`),
    meta: {
      title: () => 'Team',
      layout: Layout,
      is_public: false,
      menu: {
        key: 'Team',
        label: 'Team',
        icon: () => h(UsergroupAddOutlined),
        path: `${prefix}/team/list`,
        condition: () => {
          const identity_store = useIdentityStore()
          return (
            identity_store.auth.user.roles.includes('org_admin') ||
            identity_store.auth.user.roles.includes('super_admin')
          )
        },
      },
    },
  },
  {
    path: '/team/:id(\\d+)+',
    name: 'team-details',
    component: () => getComponent(`pages/team/team-details.vue`),
    meta: {
      title: ({ id }: { id: string }) => `Teamanization #${id}`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/team/new',
    name: 'team-new',
    component: () => getComponent(`pages/team/team-new.vue`),
    meta: {
      title: () => `New Teamanization`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/team/:id(\\d+)+/edit',
    name: 'team-edit',
    component: () => getComponent(`pages/team/team-edit.vue`),
    meta: {
      title: () => `Edit Teamanization`,
      layout: Layout,
      is_public: false,
    },
  },
]
